/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapMutations, mapGetters } from 'vuex';
import Forms from '../../utils/forms/forms';
import modulesService from '../../services/modules';
import PowerOfficeService from '../../services/poweroffice';
import organizationSettingsService from '../../services/organizationSettings';

export default {
  data() {
    return {
      form: new Forms({}),
      loading: false,
      integrationType: '',
    };
  },

  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      account: 'account',
      settings: 'organizationSettings',
    }),
  },

  mounted() {
    this.loading = true;
    const fields = {};
    let hasOptions = false;
    for (let i = 0; i < this.module.fields.length; i++) {
      const field = this.module.fields[i];
      if (field.hidden) continue;

      const newField = {
        type: this.module.fields[i].type || 'text',
        value: '',
      };
      if (this.module.fields[i].options) {
        hasOptions = true;

        if (Object.prototype.hasOwnProperty.call(field.options, 'standard')) {
        newField.value = 'standard';

      }
      }
      fields[this.module.fields[i].name] = newField;
    }

    this.form = new Forms(fields);
    if (hasOptions) {
      for (let i = 0; i < this.module.fields.length; i++) {
        if (this.module.fields[i].options) {
          const options = this.module.fields[i].options;
          this.form.setOptions(this.module.fields[i].name, Object.keys(options).map(key => ({
            id: key,
            name: options[key],
          })));
        }
      }
    }
    this.loading = false;
  },

  watch: {},

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    authorize() {
      this.form.loading = true;

      const data = Object.assign({
        user_id: this.account.userId,
      }, this.form.data());

      PowerOfficeService.authorize(data)
      .then(() => {
        this.subscribe();
        this.$message({
          showClose: true,
          message: 'PowerOffice connected successfully!',
          type: 'success',
        });

      }).catch((error) => {
        const message = error.data ? error.data.message : 'Field Required';
        this.$message({
          showClose: true,
          message,
          customClass: 'error',
        });
        this.form.loading = false;
        this.form.recordErrors(error);
      });
    },

    /**
     * Fetch the component's required resources.
     */
    getResources() {},

    subscribe() {
      this.form.loading = true;
      const obj = Object.assign({ module_id: this.module.id }, this.form.data());
      modulesService.subscribe(this.module.id, obj)
      .then(() => {
        // Initiate sync of customers and products after successful subscription
        // Similar to Fiken pattern
        Promise.all([PowerOfficeService.sync(), modulesService.items()]).then(
          () => {
            this.closeModal();
          }
        );
      })
      .catch((error) => {
        const message = error.data ? error.data.message : 'Field Required';
        this.$message({
          showClose: true,
          message,
          customClass: 'error',
        });
        this.form.recordErrors(error);
        this.form.loading = false;
      });
    },
    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/accountingSetupPowerOffice/accountingSetupPowerOffice.js